"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.parseToken = exports.generateRandom = exports.generateChallenge = void 0;var _sha = _interopRequireDefault(require("crypto-js/sha256"));
var _crypto = require("./crypto");
var _logging = require("./logging");

/* istanbul ignore next */
const generateChallenge = (code) => {
  return (0, _crypto.base64URL)((0, _sha.default)(code));
};

/* istanbul ignore next */exports.generateChallenge = generateChallenge;
const generateRandom = (size) => {
  const CHARSET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const buffer = new Uint8Array(size);
  if (typeof window !== 'undefined' && !!window.crypto) {
    window.crypto.getRandomValues(buffer);
  } else {
    for (let i = 0; i < size; i += 1) {
      buffer[i] = Math.random() * CHARSET.length | 0;
    }
  }
  return (0, _crypto.bufferToString)(buffer);
};


/**
 * Parses a JWT token
 * @param {string} token
 */exports.generateRandom = generateRandom;
const parseToken = (token) => {
  if (!token) return;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url === null || base64Url === void 0 ? void 0 : base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64).
      split('').
      map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).
      join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    _logging.Logger.error("Failed to parse token", e);
  }
};exports.parseToken = parseToken;